export default "__VITE_ASSET__Chv9WjKx__"